import m from "../../../../geodata/es2015/region/usa/mtHigh";
window.am4geodata_region_usa_mtHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/mtHigh.js
// module id = null
// module chunks = 